import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import IndexPage from 'flarum/forum/components/IndexPage';
import WelcomePage from './components/WelcomePage';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';

function isRoute(routeName: string) {
	return app.current && app.current.data && (app.current.data as any).routeName == routeName;
}

app.initializers.add('vspt/community', (app) => {
	app.routes['vspt.welcome'] = { path: '/welcome', component: WelcomePage };
});

/*extend(HeaderPrimary.prototype, 'onupdate', function() {
	let homeLink = document.getElementById('home-link');
	homeLink.setAttribute('href', 'https://vhelio.org/');
	homeLink.outerHTML = homeLink.outerHTML;
});

extend(HeaderPrimary.prototype, 'items', function(items) {
	items.add('home',
		<a href="/">communauté</a>
	);
});*/

extend(HeaderPrimary.prototype, 'onupdate', function() {
	let homeLink = document.getElementById('home-link');
	if(homeLink) {
		homeLink.classList.add('Button');
		homeLink.classList.add('Button--primary');
		homeLink.innerHTML = app.translator.trans('vspt_community.forum.header.home_link_text');
		
		let headerMain = document.getElementById('header-main');
		if(!headerMain) {
			headerMain = document.createElement('span');
			headerMain.setAttribute('id', 'header-main');
			homeLink.parentElement?.prepend(headerMain);
			
			m.render(headerMain, <a href="https://vhelio.org" id="website-link">
				<img src="/assets/extensions/vspt-community/website-logo.png" alt={app.translator.trans('vspt_community.forum.header.logo_alt')} class="Header-logo" />
			</a>);
		}

		let wikiLink = document.getElementById('wiki-link-container');
		if(!wikiLink) {
			wikiLink = document.createElement('span');
			wikiLink.setAttribute('id', 'wiki-link-container');
			homeLink.parentElement?.append(wikiLink);
			homeLink.parentElement?.appendChild(document.createTextNode(" "));
			
			m.render(wikiLink, <a href="https://wiki.vhelio.org" id="wiki-link" class="Button Button--primary">{app.translator.trans('vspt_community.forum.wiki.link')}</a>);
		}
	}
});

extend(SignUpModal.prototype, 'footer', function(vnodeArray) {
	vnodeArray.push(<p><a href="/assets/extensions/vspt-community/politique confidentialité.pdf" target="_blank">{app.translator.trans('vspt_community.forum.signup.privacy_policy')}</a></p>);
});

extend(HeaderSecondary.prototype, 'items', function(items) {
	if(isRoute('vspt.welcome')) {
		items.remove('notifications');
		items.remove('search');
		items.remove('signUp');
	}
});

override(IndexPage.prototype, 'oninit', function(original, vnode) {
	const user = app.session.user;
	if(!user && localStorage.getItem("vspt.skip-welcome") != "true") {
		m.route.set(app.routes['vspt.welcome'].path);
		return;
	}
	
	return original(vnode);
});

override(DiscussionListItem.prototype, 'view', function(original, vnode) {
	// TODO: clean up this code which is way too hacky
	
	// Check if the discussion has the documentation tag
	if(this.attrs.discussion.tags && this.attrs.discussion.tags().length > 0 && this.attrs.discussion.tags()[0].id() == 2 && !this.attrs.params.q)
	{
		let originalMostRelevantPost = this.attrs.discussion.data.attributes.mostRelevantPost;
		let originalQ = this.attrs.params.q;
		
		// hack to prevent jumping at the last read post for the specific case of documentation discussions (we are more interested by the first post, which contains the documentation)
		this.attrs.params.q = 'jqzrbqzefpqrezgjnzaeqfkbjhgr';
		this.attrs.discussion.data.attributes.mostRelevantPost = 0;
		
		// the original method internally generates routes with the target post to display ; with our hack it will always ask to jump to the first post
		let result = original(vnode);
		
		// restore original value
		this.attrs.params.q = originalQ;
		this.attrs.discussion.data.attributes.mostRelevantPost = originalMostRelevantPost;
		
		return result;
	}
	else
	{
		return original(vnode);
	}
});
